/** Штрафи вибору маски (ISO/IEC 18004 §7.8.3): серії, блоки 2×2, візерунки, схожі на шаблон пошуку, баланс темних модулів. */
const N1 = 3;
const N2 = 3;
const N3 = 40;
const N4 = 10;

/** Візерунок 1:1:3:1:1 зі світлою смугою в чотири модулі з одного боку. */
const FINDER_LIKE = ['10111010000', '00001011101'];

/** Штраф одного ряду модулів: серії від 5 однакових і візерунки, схожі на шаблон пошуку. */
function linePenalty(line: readonly boolean[]): number {
  let result = 0;
  let run = 1;
  for (let i = 1; i <= line.length; i++) {
    if (i < line.length && line[i] === line[i - 1]) { run++; continue; }
    if (run >= 5) result += N1 + (run - 5);
    run = 1;
  }
  const text = line.map((m) => (m ? '1' : '0')).join('');
  for (const pattern of FINDER_LIKE) for (let at = text.indexOf(pattern); at >= 0; at = text.indexOf(pattern, at + 1)) result += N3;
  return result;
}

/** Сумарний штраф пласкої матриці зі стороною `n` (менший — краще читається сканером). Чиста функція. */
export function qrPenalty(modules: readonly boolean[], n: number): number {
  const at = (x: number, y: number): boolean => modules[y * n + x] === true;
  let result = 0;
  let dark = 0;
  for (let y = 0; y < n; y++) {
    const row: boolean[] = [];
    const column: boolean[] = [];
    for (let x = 0; x < n; x++) {
      row.push(at(x, y));
      column.push(at(y, x));
      if (at(x, y)) dark++;
      if (x + 1 < n && y + 1 < n) {
        const c = at(x, y);
        if (c === at(x + 1, y) && c === at(x, y + 1) && c === at(x + 1, y + 1)) result += N2;
      }
    }
    result += linePenalty(row) + linePenalty(column);
  }
  const total = n * n;
  return result + (Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1) * N4;
}
